/* eslint import/no-extraneous-dependencies: 0 */
/* eslint object-shorthand: 0 */
/* eslint no-underscore-dangle: 0 */
import * as Blockly from 'blockly';
import colors from '../../utils/colors';
import { VariablesDynamicEducabot } from '../variablesDynamic/variableBlocks';
import '../variablesDynamic/customFieldVariable';

// Categoría de Variables de los perfiles que generan JavaScript. Tres bloques y no
// cinco a propósito: los _declare_*_dynamic están comentados en el fork y en prod no aparecen.
// Usa custom_field_variable como la categoría Arduino: comparten las variables del workspace.

export const VariablesJavascriptDynamicEducabot = {};

Blockly.defineBlocksWithJsonArray([
  {
    type: 'variables_javascript_get_dynamic',
    message0: '%1',
    args0: [
      { type: 'custom_field_variable', name: 'VAR', variable: '%{BKY_VARIABLES_DEFAULT_NAME}' },
    ],
    output: null,
    colour: colors.COLOUR_VARIABLES,
    helpUrl: '%{BKY_VARIABLES_GET_HELPURL}',
    tooltip: '%{BKY_VARIABLES_GET_TOOLTIP}',
  },
  {
    type: 'variables_javascript_set_dynamic',
    message0: '%{BKY_VARIABLE_STATEMENT_DEF} %1 %{BKY_VARIABLE_STATEMENT_DEF_TO} %2',
    args0: [
      { type: 'custom_field_variable', name: 'VAR', variable: '%{BKY_VARIABLES_DEFAULT_NAME}' },
      { type: 'input_value', name: 'VALUE' },
    ],
    previousStatement: null,
    nextStatement: null,
    colour: colors.COLOUR_VARIABLES,
    tooltip: '%{BKY_VARIABLES_SET_TOOLTIP}',
    helpUrl: '%{BKY_VARIABLES_SET_HELPURL}',
  },
  {
    type: 'variables_javascript_change_dynamic',
    message0: '%{BKY_VARIABLE_STATEMENT_CHANGE} %1 %{BKY_VARIABLE_STATEMENT_CHANGE_BY} %2',
    args0: [
      { type: 'custom_field_variable', name: 'VAR', variable: '%{BKY_VARIABLES_DEFAULT_NAME}' },
      { type: 'input_value', name: 'VALUE' },
    ],
    previousStatement: null,
    nextStatement: null,
    colour: colors.COLOUR_VARIABLES,
    tooltip: '%{BKY_VARIABLES_SET_TOOLTIP}',
    helpUrl: '%{BKY_VARIABLES_SET_HELPURL}',
  },
]);

VariablesJavascriptDynamicEducabot.flyoutCategoryBlocks = (workspace) => {
  const variables = workspace.getVariableMap().getAllVariables();
  if (!variables.length) return [];

  variables.sort(Blockly.Variables.compareByName);

  const blockFor = (type, variable, gap, withValue) => {
    const block = Blockly.utils.xml.createElement('block');
    block.setAttribute('type', type);
    block.setAttribute('gap', gap);
    block.appendChild(Blockly.Variables.generateVariableFieldDom(variable));
    if (withValue) {
      const value = Blockly.utils.xml.createElement('value');
      value.setAttribute('name', 'VALUE');
      const shadow = Blockly.utils.xml.createElement('shadow');
      shadow.setAttribute('type', 'math_number');
      const field = Blockly.utils.xml.createElement('field');
      field.setAttribute('name', 'NUM');
      field.textContent = withValue;
      shadow.appendChild(field);
      value.appendChild(shadow);
      block.appendChild(value);
    }
    return block;
  };

  const first = variables[0];
  const xmlList = [
    blockFor('variables_javascript_set_dynamic', first, '24', '0'),
    blockFor('variables_javascript_change_dynamic', first, '24', '1'),
  ];

  variables.forEach((variable) => {
    xmlList.push(blockFor('variables_javascript_get_dynamic', variable, '8'));
  });

  return xmlList;
};

VariablesJavascriptDynamicEducabot.flyoutCategory = function (workspace) {
  const button = document.createElement('button');
  button.setAttribute('text', Blockly.Msg.NEW_VARIABLE);
  button.setAttribute('callbackKey', 'CREATE_VARIABLE_STRING');

  // Se registra también acá porque los perfiles micro:bit no incluyen la
  // categoría Arduino; sin esto "Nueva variable" no hace nada.
  workspace.registerButtonCallback(
    'CREATE_VARIABLE_STRING',
    VariablesDynamicEducabot.onCreateVariableButtonClick_String,
  );

  return [button, ...VariablesJavascriptDynamicEducabot.flyoutCategoryBlocks(workspace)];
};
